import './login.css'
import { useState} from "react";
import { useUserAuth } from "../Login/UserAuthContext";
import { useNavigate } from 'react-router-dom';
export default function Login(){
    const [error,setError] = useState('')
    const {user} = useUserAuth()
    const {googleSignIn} = useUserAuth()
    const navigate=useNavigate()
    const handleLogin = async(e) => {
        e.preventDefault();
        await googleSignIn()
        navigate('/contactlist')
    };
    return(
        <div style={{width:'100%',height:'100vh',display:'flex',justifyContent:'center'}}>
            <div className='login-field'>
                <h1 style={{color:'white'}}><i className="fa-solid fa-comments"></i> MeChat</h1>
                {error && <h4 className='alert'>{error}</h4>}
                <div className='login-btn'>
                    <button onClick={handleLogin}><i className="fa-brands fa-google"></i> Sign in with Google</button>
                </div>
            </div>
        </div>
    )
}
